import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { RegisterPaymentAccountsRequestModel, RegisterPaymentAccountsResponseModel } from "@/features/accounts/payment/scraping/services/register-accounts-model";
import { Timeout } from "@/shared/services/http-client";

export class RegisterPaymentAccountsApi {
  /**
   * MoneyLook 口座登録API
   */
  public registerPaymentAccounts = async (
    param: RegisterPaymentAccountsRequestModel
  ): Promise<RegisterPaymentAccountsResponseModel> => {
    const path = `/api/paymentaccounts/scraping/registeraccounts`;
    const res = await ApiClient.instance.post<RegisterPaymentAccountsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
      timeout: Timeout.VeryLong,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
